import type { ReactNode } from "react";
import { useMe } from "./MeContext";
import { hasRole } from "./roleHelpers";
import { AccessDenied } from "./AccessDenied";

export function ProtectedRoute({
  roles,
  feature,
  children,
}: {
  roles: string[];
  feature: string;
  children: ReactNode;
}) {
  const me = useMe();
  if (!hasRole(me, ...roles)) return <AccessDenied feature={feature} />;
  return <>{children}</>;
}
